import { Button, Group, Text } from '@mantine/core';

export const DataTableTokenPagination = ({
    totalCount,
    nextToken,
    handleLoadMore,
}: {
    totalCount: string;
    nextToken: string | null;
    handleLoadMore: () => void;
}) => {
    return (
        <Group justify="space-between">
            <Text size="sm" c="dimmed">
                Showing {totalCount} records
            </Text>
            {nextToken && (
                <Button variant="light" size="xs" onClick={handleLoadMore}>
                    Load More
                </Button>
            )}
        </Group>
    );
};
